const scrollBehavior = (to, from, savedPosition) => {
  // если переходим на другую страницу, то скроллим наверх
  if (to.name !== from.name) {
    window.scrollTo(0, 0);
    return {
      offset: { x: 0, y: 0 },
    };
  } else if (savedPosition) {
    return {
      offset: savedPosition,
    };
  }
};

export default scrollBehavior;